import resolve from "ng";
import AppConfigBase from "servicestack/config.model.plugin";

const $timeout = resolve("$timeout");
const timeoutRoutes = ["cart", "checkout", "shop", "order", "tag", "design"];

export default class AppConfig extends AppConfigBase {
  constructor() {
    super();
  }
  init(session) {
    super.init(session);
    this.wireSessionTimeout(session);
  }

  registerLuckyOrange(siteId) {
    window.__lo_site_id = siteId;
    var wa = document.createElement("script");
    wa.type = "text/javascript";
    wa.async = true;
    wa.src = "https://d10lpsik1i8c69.cloudfront.net/w.js";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(wa, s);
  }

  resetSessionTimeout(session, ev) {
    //console.debug('resetSessionTimeout',ev);
    $timeout.cancel(session.timeoutToken);
    session.timeoutToken = $timeout(() => {
      this.promptSessionTimeout(session);
    }, this.sessionTimeout);
  }

  wireSessionTimeout(session) {
    //console.debug('wireSessionTimeout',session, this);
    if (this.sessionTimeout) {
      angular
        .element(document)
        .on("keydown mousedown mousewheel wheel", (ev) =>
          this.resetSessionTimeout(session, ev)
        ); //mousemove
      this.resetSessionTimeout(session, { init: new Date() });
    }
  }

  onTimedout(session) {
    let $rootScope = resolve("$rootScope");
    $rootScope.$broadcast("onTimedout", session);
    let unsubsribe = $rootScope.$on("$onLogout", () =>
      unsubsribe((location.href = "/"))
    );
    return session.logout();
  }

  promptSessionTimeout(session) {
    let route = resolve("$state").current.name;
    let $cart = resolve("$cart");
    //console.debug('promptSessionTimeout',route, timeoutRoutes.map(tr => {return {tr, i:route.indexOf(tr)};}));

    if (
      $cart.items.length === 0 &&
      timeoutRoutes.filter((tr) => route.indexOf(tr) === 0).length === 0
    ) {
      //console.debug('skip timeout, route:', route, timeoutRoutes.filter(tr => route.indexOf(tr) === 0), 'cart items:', $cart.items.length);
      return this.resetSessionTimeout(session);
    }

    let mi = resolve("modals").dialog({
      body: `You've been inactive for a while, would you like to continue?`,
      title: `Are you still there?`,
      size: "md",
      buttons: {
        Continue: {},
        "Start Over": {
          dismiss: true,
          className: "btn-u-default",
        },
      },
    });

    let token = $timeout(() => {
      mi.close();
      this.onTimedout(session);
      //console.warn('promptSessionTimeout.TOOLONG',token, session, this);
    }, this.sessionTimeout / 2);

    mi.result
      .then(
        (result) => console.log("promptSessionTimeout.Ok", result),
        (b) =>
          console.warn(
            "promptSessionTimeout.Dismiss",
            b,
            this.onTimedout(session)
          )
      )
      .finally(() =>
        console.warn(
          "finally",
          token,
          $timeout.cancel(token),
          this.resetSessionTimeout(session)
        )
      );
  }

  search(keywords) {
    // console.debug("this.keywords", keywords, this);
    let $session = resolve("$session");
    //let $state = resolve('$state');
    let $rootScope = resolve("$rootScope");
    let args = { keywords };
    $rootScope.$broadcast("appSearch", args);
    // console.debug("appSearch.args", args);
    if (!args.handler) {
      let url = location.hash ? "#" : "";
      let origLocation = location.href;
      //https://emun1.monday.com/boards/333027351/views/4635648/pulses/4118794218
      url +=
        (location.href.indexOf("/fr/") >= 0 ? "/fr" : "") +
        `/shop/?Referrer=AppSearch&ListId=&Search=${encodeURIComponent(
          keywords
        )}`;
      console.warn("this.keywords", location.hash, { url });
      location.href = url;
      if (
        origLocation.indexOf("/shop") >= 0 &&
        $session.isSalesManagementMode()
      ) {
        $timeout(function () {
          location.reload();
        }, 500);
      }
    } else {
      console.debug("args.handler", args.handler);
    }
  }
}
